import { Component, Input, OnInit } from '@angular/core';
import { SettingsService, TOASTERCONFIG } from '@app/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import { UserService } from '@app/services';
import { ToasterService, Toast } from 'angular2-toaster';
import { GetApiurl, authTokenId } from '../../../core/settings/config';
import { ValidationService } from '@app/shared/directives';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FileUploader, FileLikeObject } from 'ng2-file-upload';
import { AuthService } from '@app/auth';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

declare var $: any;
declare var jQuery: any;

@Component({
    selector: 'app-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {

    user: any;
    imageSrc: any = 'assets/img/default-user.png';
    upload_file: any;
    password_build_form: FormGroup;
    account_form: FormGroup;
    passwordForm: FormGroup;
    show_form = false;
    settingProcess = false;
    passProcess = false;
    image_process = false;
    toasterConfig = TOASTERCONFIG;
    method = 'POST';
    edit_id: any;
    whichOne: String = 'profile';
    image: any;
    application_id: any;
    process = false;
    form_enabled = false;
    password_view = { current: false, newPassword: false, confirm: false };
    DateTime = new Date();

    pass_valid = [];
    isEdit: boolean = false;
    save_enable: boolean = false;
    psswrdboolean: boolean = false;

    constructor(
        private router: Router,
        private settingsService: SettingsService,
        private fb: FormBuilder,
        private userService: UserService,
        private authService: AuthService,
        private toasterService: ToasterService,
    ) {
        const password = new FormControl('', Validators.compose([Validators.required]));
        const certainPassword = new FormControl('', CustomValidators.equalTo(password));
        this.passwordForm = fb.group({
            'password': password,
            'confirmPassword': certainPassword
        });

    }

    ngOnInit() {
        this.settingsService.user$.subscribe(settings => {
            this.user = settings;
            if (this.user['firstName'] != null) {
                this.form_enabled = false;
                this.updateForm()
            }
            else {
                this.buildForm();
                this.form_enabled = true;
            }
            this.process = true;
            if (this.user['profile_image'] != null) {
                this.imageSrc = GetApiurl(this.user['profile_image'].substr(1)) + '?' + this.DateTime;
            }

            if (!this.user['isSuperUser'] && this.user['id']) {
                this.user['companyName'] = this.user['id'];
                this.userService.getCompanyData(this.user['id'])
                    .subscribe(resp => {
                        this.user['companyName'] = resp['company_name'];
                    });
            }

            this.edit_id = this.user['id'];
        });
        $('#profileModal').on('show.bs.modal', () => {
            $('body').css('overflow', 'hidden');
        })
        $('#profileModal').on('hidden.bs.modal', () => {
            $('body').css('overflow', 'auto');
        })
    }
    @Input('enabled')
    set enabled(data) {
        if (data == false) {
            this.form_enabled = false;
        }
    }

    open_profile_modal() {
        $('#profileModal').modal('show');
        this.account_form.disable();// diable profile modal form           

    }

    back() {
        $('#profileModal').modal('hide');
        this.test('profile')
        // this.isEdit = false;
        // this.account_form.disable(); 
        this.updateForm()
        this.password_build_form.reset();
        this.password_view = { current: false, newPassword: false, confirm: false };
        // this.form_enabled = false;

        let maildisabled: HTMLElement = document.getElementById("emailDisabled");
        if (maildisabled) {
            maildisabled['disabled'] = true;
            maildisabled.style.backgroundColor = '';
            maildisabled.style.color = '';
        }
        // this.whichOne = 'profile';

    }


    buildForm() {
        this.account_form = this.fb.group({
            'firstName': [this.user['firstName'], [Validators.required, Validators.maxLength(30), ValidationService.userNameValidator]],
            'lastName': [this.user['lastName'], [Validators.required, Validators.maxLength(100), ValidationService.userNameValidator]],
            'email': [this.user['email'], [Validators.required, ValidationService.emailValidator]],
            'mobile': [this.user['mobile'], [Validators.required, ValidationService.phoneValidator]],
            // 'companyName': [this.user['companyName'], Validators.required]
        });
        this.build_password_form();
    }
    updateForm() {
        this.account_form = this.fb.group({
            'firstName': [{ value: this.user['firstName'], disabled: true }, [Validators.required, Validators.maxLength(30), ValidationService.userNameValidator]],
            'lastName': [{ value: this.user['lastName'], disabled: true }, [Validators.required, Validators.maxLength(100), ValidationService.userNameValidator]],
            'email': [{ value: this.user['email'], disabled: true }, [Validators.required, ValidationService.emailValidator]],
            'mobile': [{ value: this.user['mobile'], disabled: true }, [Validators.required, ValidationService.phoneValidator]],
            // 'companyName': [{value:this.user['companyName'],disabled:true}, Validators.required]
        });
        this.build_password_form();
        // Validators.pattern(/[^\s]+/)
    }

    build_password_form() {
        this.password_build_form = this.fb.group({
            // 'current_password': ['', Validators.required],
            'passwordGroup': this.passwordForm
        });
        this.show_form = true;
    }

    test(flag) {

        this.updateForm()
        this.whichOne = flag;
        this.form_enabled = false;
        this.account_form.disable();
        this.isEdit = false;
        this.passwordForm.reset();
    }

    uploadFile() {
        $('#image-input').trigger('click');
        this.form_enabled = false;
        this.isEdit = false;
        this.account_form.disable();
        let maildisabled: HTMLElement = document.getElementById("emailDisabled");
        maildisabled['disabled'] = true;
        maildisabled.style.backgroundColor = '';
        maildisabled.style.color = '';

    }

    onSelectFile(event) {
        if (event.target.files && event.target.files[0]) {
            this.image_process = true;
            const file = event.target.files[0];
            this.upload_file = file;
            this.image = file.type;
            const allowed_types = ['image/png', 'image/jpeg', 'image/jpg', 'image/bmp', 'image/gif'];
            if (allowed_types.includes(this.image)) {
                this.UploadImage().then(result => {
                    if (result) {
                        const reader = new FileReader();
                        reader.onload = e => this.imageSrc = reader.result;
                        reader.readAsDataURL(file);
                        // this.imageSrc = GetApiurl(result['data']['profile_image']);
                        result['data']['isAdmin'] = this.user['isAdmin']
                        result['data']['latest_app'] = this.user['latest_app']
                        this.settingsService.setUser(result['data']);
                        this.toasterService.pop(<Toast>{
                            type: 'success',
                            title: 'Your Profile has been Changed'
                        });
                        this.image_process = false;
                        this.form_enabled = false;
                        this.isEdit = false;
                        this.account_form.disable();
                        let maildisabled: HTMLElement = document.getElementById("emailDisabled");
                        maildisabled['disabled'] = true;
                        maildisabled.style.backgroundColor = '';
                        maildisabled.style.color = '';
                    }
                })
                    .catch(error => {
                        this.toasterService.pop(<Toast>{
                            type: 'error',
                            title: error
                        });
                        this.image_process = false;
                        this.form_enabled = false;
                        this.isEdit = false;
                        this.account_form.disable();
                        let maildisabled: HTMLElement = document.getElementById("emailDisabled");
                        maildisabled['disabled'] = true;
                        maildisabled.style.backgroundColor = '';
                        maildisabled.style.color = '';
                    });
            } else {
                this.toasterService.pop(<Toast>{
                    type: 'error',
                    title: 'Image type not supported'
                });
                this.form_enabled = false;
                this.isEdit = false;
                this.account_form.disable();
                let maildisabled: HTMLElement = document.getElementById("emailDisabled");
                maildisabled['disabled'] = true;
                maildisabled.style.backgroundColor = '';
                maildisabled.style.color = '';
            }
        }
    }

    UploadImage(): Promise<any> {
        const url: any = GetApiurl(`user/${this.edit_id}/profile-image/`);
        const formData: FormData = new FormData();
        return new Promise((resolve, reject) => {
            formData.append('profile_image', this.upload_file, this.upload_file.name);
            formData.append('user_id', this.user['id']);
            const xhr = new XMLHttpRequest();
            xhr.open('post', url, true);
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            xhr.setRequestHeader('Authorization', 'JWT ' + localStorage.getItem(authTokenId));
            xhr.send(formData);
            xhr.onreadystatechange = function () {
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    if (xhr.status === 200) {
                        resolve(JSON.parse(xhr.response));
                    } else {
                        reject(xhr.response);
                    }
                }
            };
        });
    }

    Changepassword() {
        this.passProcess = true;
        const form_data = this.password_build_form.value;
        const data = {
            'password': form_data['passwordGroup']['password']
        };
        this.userService.changePassword(data).subscribe(
            (res: object[]) => {
                this.passProcess = false;
                if (res['type'] === 'success') {
                    this.password_build_form.reset();
                    this.back();
                }
                this.toasterService.pop(<Toast>{
                    type: res['type'],
                    title: res['msg'],
                });
                this.psswrdboolean = false;
            },
            error => {
                this.toasterService.pop(<Toast>{
                    type: 'error',
                    title: error
                });
                this.passProcess = false;
                this.psswrdboolean = false;
            }
        );
        this.password_view = { current: false, newPassword: false, confirm: false };
    }
    updateProfile() {
        this.isEdit = true;
        this.form_enabled = true;
        this.account_form.enable();
        let maildisabled: HTMLElement = document.getElementById("emailDisabled");
        maildisabled['disabled'] = true;
        maildisabled.style.backgroundColor = '#9b9b9b85';
        maildisabled.style.color = '#0c0c0c4f';

    }
    hasFormChanged(place) {
        this.save_enable = false
        if (this.user.firstName != this.account_form.value.firstName || this.user.lastName != this.account_form.value.lastName || this.user.mobile != this.account_form.value.mobile) {
            this.save_enable = true
        }

    }

    submitProfile() {
        this.isEdit = false;
        this.settingProcess = true;
        this.userService.updateProfile(this.account_form.value, this.edit_id).subscribe(
            (res: object[]) => {
                res['data']['accesses'] = this.user['accesses']
                res['data']['isAdmin'] = this.user['isAdmin']
                res['data']['latest_app'] = this.user['latest_app']
                this.settingsService.setUser(res['data']);
                if (res['data']['profile_image'] != null) {
                    this.imageSrc = GetApiurl(res['data']['profile_image'].substr(1)) + "?" + Math.floor(Math.random() * 100) + 1;
                }
                this.user['first_name'] = res['data']['first_name']
                this.settingProcess = false;
                this.user['companyName'] = res['data']['companyName'];
                $('#profileModal').modal('hide')
                // $('body').removeClass('modal-open');
                $('.modal-backdrop').remove();
                // this.back();
                this.toasterService.pop(<Toast>{
                    type: 'success',
                    title: 'Profile Saved',
                });
                this.form_enabled = false;
                this.account_form.disable();
                let maildisabled: HTMLElement = document.getElementById("emailDisabled");
                maildisabled['disabled'] = true;
                maildisabled.style.backgroundColor = '';
                maildisabled.style.color = '';


                // this.authService.redirectToHome();
            },
            error => {
                this.toasterService.pop(<Toast>{
                    type: 'error',
                    title: error
                });
                this.settingProcess = false;
            }
        );
    }

    onKeyUp(event) {
        if ($('popover-container')) {
            // $('popover-container').remove()
            $('popover-container').css('display', 'none')
        }
        let value = event.target.value;
        let number_exists = /\d/.test(value);
        this.pass_valid = [];
        // this.pass_valid[0]=false;
        if (value.length < 8) {
            this.pass_valid[0] = true;
        }
        // this.pass_valid[1]=false;
        if (value.search(/[0-9]/) < 0) {
            this.pass_valid[1] = true;
        }
        // this.pass_valid[2]=true;
        if (value.search(/[a-z]/) < 0) {
            this.pass_valid[2] = true;
        }
        // this.pass_valid[3]=true;
        if (value.search(/[A-Z]/) < 0) {
            this.pass_valid[3] = true;
        }
        // this.pass_valid[4]=true;
        if (value.search(/[!@#\$%\^&\*_]/) < 0) {
            this.pass_valid[4] = true;
        }
        if (value.length >= 50) {
            this.psswrdboolean = true;
        }
        else {
            this.psswrdboolean = false;
        }
    }
    onClick() {
        if ($('popover-container')) {
            // $('popover-container').remove()
            $('popover-container').css('display', 'none')
        }
        // if(document.getElementById('#popoverTemp')){
        //     document.getElementById('#popoverTemp').remove()
        // }
    }

    ngOnDestroy() {
        if ($('popover-container')) {
            // $('popover-container').remove()
            $('popover-container').css('display', 'none')
        }
        $('#profileModal').modal('hide')
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
    }
}
